exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-container{display:flex;width:100%;justify-content:space-between;background-color:var(--aluminium-5);height:64px;border-radius:4px 0 0 0;padding:1rem 1.5rem 1rem 1rem;border-bottom:1px solid #fff}.header-container .left-side{display:flex;justify-content:flex-start}.header-container .right-side{display:flex;justify-content:flex-end}.header-container .action-button{margin-left:1rem}", ""]);

// exports
